import React, {useState, useEffect, useCallback} from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import GenericMapWithMarker from '../../../GenericMapWithMarker';

const OVERLAY_VIEW_POSITION_OFFSET = {x: -105, y: -215};
const WINDOW_DIMENSION_LIMIT = 768;

interface LatLngInterface {
  index?: number;
  lat: number;
  lng: number;
}

interface ClinicMapProps {
  clinics: any[];
  buStyles: any;
  labels: any;
  showPrice?: boolean;
  precoEstimadoFuncAtiva: boolean;
  infoBoxPosition: LatLngInterface | null;
  multipleClinics: boolean;
  offset?: number;
  handleChangeInfoBoxPosition(value: LatLngInterface | null): void;
}

const ClinicMap = ({
  clinics,
  labels,
  showPrice,
  buStyles,
  infoBoxPosition,
  precoEstimadoFuncAtiva,
  multipleClinics,
  offset,
  handleChangeInfoBoxPosition,
}: ClinicMapProps) => {
  const [currentMap, setCurrentMap] = useState<google.maps.Map | null>(null);

  const handleMarkerClick = (
    index: number,
    latitude: number,
    longitude: number
  ) => {
    handleChangeInfoBoxPosition({index, lat: latitude, lng: longitude});
  };

  const onLoad = (map: google.maps.Map) => {
    setCurrentMap(map);
  };

  const getOffsetY = useCallback(() => {
    return 0.35;
  }, []);

  const getOffsetX = useCallback(() => {
    if (window.screen.width < WINDOW_DIMENSION_LIMIT && multipleClinics) {
      return 0.005;
    }

    if (window.screen.width < WINDOW_DIMENSION_LIMIT && !multipleClinics) {
      return 0.03;
    }

    return 0;
  }, [multipleClinics]);

  const recenterMapOffset = useCallback(() => {
    if (currentMap && infoBoxPosition) {
      const offsetX = getOffsetX();
      const offsetY = getOffsetY();
      const span = currentMap?.getBounds()?.toSpan();
      if (span) {
        currentMap.panTo(
          new window.google.maps.LatLng(
            infoBoxPosition?.lat + span.lat() * offsetY,
            infoBoxPosition?.lng + span.lng() * offsetX
          )
        );
      }
    }
  }, [currentMap, infoBoxPosition, getOffsetY, getOffsetX]);

  useEffect(() => {
    if (currentMap) {
      // if (!infoBoxPosition) {
      //   handleChangeInfoBoxPosition({
      //     index: 0,
      //     lat: clinics[0].latitude,
      //     lng: clinics[0].longitude,
      //   });
      //   return;
      // }
      google.maps.event.addListenerOnce(
        currentMap,
        'bounds_changed',
        recenterMapOffset
      );
      if (clinics.length > 1) {
        recenterMapOffset();
      }
    }
  }, [
    currentMap,
    clinics,
    recenterMapOffset,
    infoBoxPosition,
    handleChangeInfoBoxPosition,
    offset,
  ]);

  return clinics.length ? (
    <GenericMapWithMarker
      buStyles={buStyles}
      enablePriceMarker={false}
      precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
      offset={OVERLAY_VIEW_POSITION_OFFSET}
      currentMap={currentMap}
      onLoad={onLoad}
      locations={clinics}
      showPrice={showPrice}
      infoBoxPosition={infoBoxPosition}
      zoom={12}
      handleMarkerClick={handleMarkerClick}
      handleChangeInfoBoxPosition={handleChangeInfoBoxPosition}
      containerStyleClassName="clinic-location-map-component"
      withDirections
    />
  ) : null;
};

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.rede,
});

export default compose(connect(mapStateToProps)(ClinicMap));
